export const EN = 'en'
export const DE = 'de'
